"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectToken = void 0;
const PlatformToken_1 = require("../util/PlatformToken");
class ProjectToken extends PlatformToken_1.PlatformToken {
    constructor(token) {
        super(ProjectToken.TOKEN_TYPE, token);
    }
    get projectId() {
        return this.subject;
    }
}
exports.ProjectToken = ProjectToken;
ProjectToken.TOKEN_TYPE = 'project';
//# sourceMappingURL=ProjectToken.js.map